import React from 'react';
import { Church } from 'lucide-react';
import './Auth.css';

const AuthLayout = ({ children, title, subtitle }) => {
  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo">
            <span className="logo-icon"><Church size={28} strokeWidth={1.5} /></span>
            <span className="logo-text">FaithConnect</span>
          </div>
          <h1 className="auth-title">{title}</h1>
          {subtitle && <p className="auth-subtitle">{subtitle}</p>}
        </div>
        <div className="auth-body-scrollable">
          {children}
        </div>
        <div className="auth-footer">
          <p>&copy; 2026 FaithConnect. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;